module.exports = __webpack_public_path__ + "img/social-streetwear-drop.bc0772b9.jpg";